import { AnyFeedItemEntityVersion } from '@uploadcam/common';
import { CollectionReference, doc, Firestore, runTransaction } from 'firebase/firestore';

export class RemoveFeedItemsInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyFeedItemEntityVersion>,
    private readonly db: Firestore,
  ) {}

  public async execute(feedItemIds: string[]): Promise<void> {
    await runTransaction(this.db, async (transaction) => {
      feedItemIds.forEach((id) => {
        const docRef = doc(this.collection, id);
        transaction.delete(docRef);
      });
    });
  }
}
